import { render, staticRenderFns } from "./EditRecord.vue?vue&type=template&id=07c9018f&scoped=true"
import script from "./EditRecord.vue?vue&type=script&lang=js"
export * from "./EditRecord.vue?vue&type=script&lang=js"
import style0 from "./EditRecord.vue?vue&type=style&index=0&id=07c9018f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c9018f",
  null
  
)

export default component.exports